import * as React from "react";
import { Button } from "@react-email/button";
import {
  Img,
  Heading,
  Row,
  Section,
  Column,
  Container,
  Link,
  Hr,
} from "@react-email/components";
import { Text } from "@react-email/text";
import Layout from "../components/Layout";

export const name = "CartAbandonment";
export const subject = "{{subject}}";

export function template({
  event_name,
  event_url,
  cart_abandonment_url,
  venue_name,
  first_name,
}: {
  event_name: string;
  venue_name: string;
  first_name: string;
  event_url: string;
  cart_abandonment_url: string;
}) {
  return (
    <Layout language="en" title={event_name}>
      <Container style={{ paddingTop: "40px" }}>
        <Text style={{ fontSize: 18 }}>Hey {first_name},</Text>
        <Text style={{ fontSize: 18 }}>
          It's your man, Mike Nasty. I don't want you to miss out on the
          incredible experience of {event_name} tonight at {venue_name}.
        </Text>
        <Text style={{ fontSize: 18 }}>
          Grab your last minute tickets to {event_name} below. Prices will go up
          at the door.
        </Text>
        <Text style={{ fontSize: 18 }}>
          I'm looking forward to enjoying summer 2023 with you.
        </Text>
        <Button
          href={cart_abandonment_url}
          style={{
            backgroundColor: "white",
            borderRadius: "45px",
            fontWeight: "bold",
            letterSpacing: "2px",
            borderWidth: "3px",
            padding: "15px 40px",
            color: "black",
            fontSize: "16px",
            margin: "16px auto",
          }}
        >
          🎟️ GET TICKETS
        </Button>
        <Hr style={{ borderWidth: "5px" }} />
      </Container>
      <Img width={"100%"} style={{ margin: "8px auto" }} src={event_url} />
      <Section>
        <Row>
          <Column>
            <Text style={{ fontSize: "14px", lineHeight: "22px" }}>
              Powered By KYD Labs Inc <br />
              228 Park Avenue South, #99043 <br />
              New York, NY 10003 <br />
              <Link style={{ color: "white" }} href="https://www.kydlabs.com">
                www.kydlabs.com
              </Link>
            </Text>
          </Column>
        </Row>
      </Section>
    </Layout>
  );
}

template.PreviewProps = {
  event_name: "Test event",
  event_url: "/static/coachella.jpg",
  organization_name: "Organizers Inc.",
  cart_abandonment_url:
    "https://coachella.kydlabsdemo.com/e/EV3cfb122a-277b-4c93-9b8d-f8003a015a38/wallet",
  first_name: "David",
  venue_name: "BrooklynBowl",
};

export default template;
